export const APP_URL = '/'
export const TIME_UPDATE = 5*60*1000